import React, { useState } from 'react';
import { BallTriangle } from 'react-loader-spinner';
import PlacementDetails from './PlacementDetails';

const StudentOverviewTable = ({
  data,
  mcqData,
  qaData,
  mcqAssignmentData,
  qaAssignmentData,
  mockData,
  finalMockData,
  placementData,
  loadingPlacement,
  isLoading,
}) => {
  const [expandedRows] = useState(() =>
    data?.studentOverviews?.reduce((acc, student) => {
      acc[student.studentId] = true;
      return acc;
    }, {})
  );

  const getStatusBadgeColor = (status) => {
    if (status.submitted && !status.isLate)
      return 'bg-green-100 text-green-800';
    if (status.submitted && status.isLate)
      return 'bg-yellow-100 text-yellow-800';
    return 'bg-red-100 text-red-800';
  };

  const getStatusText = (status) => {
    if (status.submitted && !status.isLate) return 'Submitted';
    if (status.submitted && status.isLate) return 'Late';
    return 'Pending';
  };

  const getTestStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-green-100 text-green-800';
      case 'in_progress':
        return 'bg-yellow-100 text-yellow-800';
      case 'not started':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const findStudentTestData = (studentId, testData) => {
    return testData?.studentOverviews?.find(
      (student) => student.studentId === studentId
    );
  };

  if (isLoading) {
    return (
      <div className="flex h-[400px] w-full items-center justify-center">
        <div className="flex flex-col items-center gap-2">
          <BallTriangle color="#5431ed" />

          <p className="text-sm text-gray-500">Loading student data...</p>
        </div>
      </div>
    );
  }

  if (!data?.studentOverviews?.length) {
    return (
      <div className="flex h-[400px] w-full items-center justify-center rounded-lg border border-dashed border-gray-300 bg-gray-50">
        <div className="flex flex-col items-center gap-2 p-4 text-center">
          <div className="rounded-full bg-gray-100 p-3">
            <svg
              className="h-6 w-6 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
              />
            </svg>
          </div>
          <h3 className="text-sm font-medium text-gray-900">
            No students found
          </h3>
          <p className="text-sm text-gray-500">
            There are no students enrolled in this class yet.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full border-collapse bg-white dark:bg-navy-800">
        <thead className="bg-gray-50 dark:border-b dark:border-gray-800 dark:bg-navy-900">
          <tr>
            <th className="w-10 px-4 py-3"></th>
            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 dark:text-white ">
              Student Name
            </th>
            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 dark:text-white">
              Email
            </th>
            <th className="px-4 py-3 text-center text-sm font-semibold text-gray-900 dark:text-white">
              Practical Assignment
            </th>
            <th className="px-4 py-3 text-center text-sm font-semibold text-gray-900 dark:text-white">
              MCQ Assignment
            </th>
            <th className="px-4 py-3 text-center text-sm font-semibold text-gray-900 dark:text-white">
              Q&A Assignment
            </th>
            <th className="px-4 py-3 text-center text-sm font-semibold text-gray-900 dark:text-white">
              MCQ Test
            </th>
            <th className="px-4 py-3 text-center text-sm font-semibold text-gray-900 dark:text-white">
              Q&A Test
            </th>
            <th className="px-4 py-3 text-center text-sm font-semibold text-gray-900 dark:text-white">
              Mock Test
            </th>
            <th className="px-4 py-3 text-center text-sm font-semibold text-gray-900 dark:text-white">
              Final Mock Test
            </th>
            <th className="px-4 py-3 text-center text-sm font-semibold text-gray-900 dark:text-white">
              Attendance
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {data?.studentOverviews?.map((student) => {
            const mcqStudent = findStudentTestData(student.studentId, mcqData);
            const qaStudent = findStudentTestData(student.studentId, qaData);
            const mcqAssignment = findStudentTestData(
              student.studentId,
              mcqAssignmentData
            );
            const qaAssignment = findStudentTestData(
              student.studentId,
              qaAssignmentData
            );
            const mockStudent = findStudentTestData(student.studentId, mockData);
            const finalMockStudent = findStudentTestData(student.studentId, finalMockData);

            return (
              <React.Fragment key={student.studentId}>
                <tr className="hover:bg-gray-50 dark:bg-navy-900 hover:dark:bg-navy-900">
                  <td className="px-4 py-3">
                    {/* <button
                      onClick={() => toggleRow(student.studentId)}
                      className="text-gray-500 hover:text-gray-700"
                    >
                      {expandedRows[student.studentId] ? '▼' : '▶'}
                    </button> */}
                  </td>
                  <td className="px-4 py-3 text-sm font-medium text-gray-900 dark:text-white">
                    {student.name}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-800 dark:text-white ">
                    {student.email}
                  </td>
                  <td className="px-4 py-3 text-navy-800 dark:text-white">
                    <div className="flex flex-col items-center">
                      <span className="text-sm font-medium">
                        {student.statistics.submittedAssignments}/
                        {student.statistics.totalAssignments}
                      </span>
                      <span className="mt-1 rounded-full bg-gray-100 px-2 py-1 text-xs text-navy-800">
                        {student.statistics.submissionRate}%
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-navy-800 dark:text-white">
                    <div className="flex flex-col items-center">
                      <span className="text-sm font-medium">
                        {mcqAssignment?.statistics.completedAssignments || 0}/
                        {mcqAssignment?.statistics.totalAssignments || 0}
                      </span>
                      <span className="mt-1 rounded-full bg-gray-100 px-2 py-1 text-xs text-navy-800">
                        {mcqAssignment?.statistics.overallPercentage || '0'}%
                      </span>
                    </div>
                  </td>
                  {/* Q&A Assignment */}
                  <td className="px-4 py-3 text-navy-800 dark:text-white">
                    <div className="flex flex-col items-center">
                      <span className="text-sm font-medium">
                        {qaAssignment?.statistics.completedAssignments || 0}/
                        {qaAssignment?.statistics.totalAssignments || 0}
                      </span>
                      <span className="mt-1 rounded-full bg-gray-100 px-2 py-1 text-xs text-navy-800">
                        {qaAssignment?.statistics.overallPercentage || '0'}%
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-navy-800 dark:text-white">
                    <div className="flex flex-col items-center">
                      <span className="text-sm font-medium">
                        {mcqStudent?.statistics.completedTests || 0}/
                        {mcqStudent?.statistics.totalTests || 0}
                      </span>
                      <span className="mt-1 rounded-full bg-gray-100 px-2 py-1 text-xs text-navy-800">
                        {mcqStudent?.statistics.overallPercentage || '0'}%
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-navy-800 dark:text-white">
                    <div className="flex flex-col items-center">
                      <span className="text-sm font-medium">
                        {qaStudent?.statistics.completedTests || 0}/
                        {qaStudent?.statistics.totalTests || 0}
                      </span>
                      <span className="mt-1 rounded-full bg-gray-100 px-2 py-1 text-xs text-navy-800">
                        {qaStudent?.statistics.overallPercentage || '0'}%
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-navy-800 dark:text-white">
                    <div className="flex flex-col items-center">
                      <span className="text-sm font-medium">
                        {mockStudent?.statistics.totalTests || 0}
                      </span>
                      <span className="mt-1 rounded-full bg-gray-100 px-2 py-1 text-xs text-navy-800">
                        {mockStudent?.statistics.averageScore || '0'}%
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-navy-800 dark:text-white">
                    <div className="flex flex-col items-center">
                      <span className="text-sm font-medium">
                        {finalMockStudent?.statistics.totalTests || 0}
                      </span>
                      <span className="mt-1 rounded-full bg-gray-100 px-2 py-1 text-xs text-navy-800">
                        {finalMockStudent?.statistics.averageScore || '0'}%
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-navy-800 dark:text-white">
                    <div className="flex flex-col items-center">
                      <span className="text-sm font-medium">
                        {student.attendanceDetails
                          ? `${student.attendanceDetails.presentLectures} / ${student.attendanceDetails.totalLectures}`
                          : '- / -'}
                      </span>
                      <span className="mt-1 rounded-full bg-gray-100 px-2 py-1 text-xs text-navy-800">
                        {student.attendanceDetails
                          ? `${student.attendanceDetails.attendancePercentage}%`
                          : 'N/A'}

                      </span>
                    </div>
                  </td>

                </tr>
                {expandedRows[student.studentId] && (
                  <tr>
                    <td
                      colSpan={12}
                      className="bg-gray-50 px-4 py-4 dark:bg-navy-900 dark:text-white"
                    >
                      <div className="rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-navy-900 ">
                        {/* Attendance Details Section */}
                        <div className="mb-6">
                          <h4 className="mb-4 text-sm font-semibold">
                            Attendance Details
                          </h4>
                          <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                            <div className="rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-navy-900">
                              <h5 className="mb-2 text-sm font-medium">
                                Overview
                              </h5>
                              <div className="space-y-2 text-sm">
                                <p className="flex justify-between">
                                  <span>Total Lectures:</span>
                                  <span>
                                    {student.attendanceDetails?.totalLectures ??
                                      'N/A'}

                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>Present Lectures:</span>
                                  <span>
                                    {student.attendanceDetails
                                      ?.presentLectures ?? 'N/A'}

                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>Absent Lectures:</span>
                                  <span>
                                    {student.attendanceDetails
                                      ?.absentLectures ?? 'N/A'}

                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>Attendance %:</span>
                                  <span>
                                    {student.attendanceDetails
                                      ?.attendancePercentage ?? 'N/A'}

                                    %
                                  </span>
                                </p>
                              </div>
                            </div>
                            <div className="rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-navy-900">
                              <h5 className="mb-2 text-sm font-medium">
                                Absent Dates
                              </h5>
                              <div className="max-h-40 space-y-1 overflow-y-auto text-sm">
                                {student.attendanceDetails?.absentDates
                                  ?.length > 0 ? (
                                  student.attendanceDetails.absentDates.map(
                                    (date, idx) => <p key={idx}>{date}</p>
                                  )
                                ) : (
                                  <p>None</p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="mb-6">

                          <h4 className="mb-4 text-sm font-semibold">
                            Practical Assignment Details
                          </h4>
                          <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                            {/* Statistics Panel */}
                            <div className="rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-navy-900">
                              <h5 className="mb-2 text-sm font-medium">
                                Overview
                              </h5>
                              <div className="space-y-2 text-sm">
                                <p className="flex justify-between">
                                  <span>Total Assignments:</span>
                                  <span>
                                    {student.statistics.totalAssignments}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>Submitted:</span>
                                  <span>
                                    {student.statistics.submittedAssignments}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>On Time:</span>
                                  <span>
                                    {student.statistics.onTimeSubmissions}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>Late:</span>
                                  <span>
                                    {student.statistics.lateSubmissions}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>Pending:</span>
                                  <span>
                                    {student.statistics.pendingSubmissions}
                                  </span>
                                </p>
                              </div>
                            </div>

                            {/* Assignment Status Panel */}
                            <div className="rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-navy-900">
                              <h5 className="mb-2 text-sm font-medium">
                                Assignment Status
                              </h5>
                              <div className="space-y-2">
                                {student.assignmentStatus.map((assignment) => (
                                  <div
                                    key={assignment.assignmentId}
                                    className="flex items-center justify-between border-b border-gray-100 pb-2 text-sm last:border-0 last:pb-0 dark:border-gray-800"
                                  >
                                    <span
                                      className="max-w-[200px] truncate"
                                      title={assignment.title}
                                    >
                                      {assignment.title}
                                    </span>
                                    <span
                                      className={`rounded-full px-2 py-1 text-xs ${getStatusBadgeColor(
                                        assignment
                                      )}`}
                                    >
                                      {getStatusText(assignment)}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>

                        {/*  Assignmnet Details Section*/}

                        {/* MCQ Assignment Details Section */}
                        <div className="mb-6">
                          <h4 className="mb-4 text-sm font-semibold">
                            MCQ Assignment Details
                          </h4>
                          <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                            <div className="rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-navy-900">
                              <h5 className="mb-2 text-sm font-medium">
                                Overview
                              </h5>
                              <div className="space-y-2 text-sm">
                                <p className="flex justify-between">
                                  <span>Total Assignments:</span>
                                  <span>
                                    {mcqAssignment?.statistics
                                      .totalAssignments || 0}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>Completed:</span>
                                  <span>
                                    {mcqAssignment?.statistics
                                      .completedAssignments || 0}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>In Progress:</span>
                                  <span>
                                    {mcqAssignment?.statistics
                                      .inProgressAssignments || 0}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>Average Score:</span>
                                  <span>
                                    {mcqAssignment?.statistics.averageScore ||
                                      0}
                                    %
                                  </span>
                                </p>
                              </div>
                            </div>
                            {mcqAssignment?.assignmentStatus && (
                              <div className="rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-navy-900">
                                <h5 className="mb-2 text-sm font-medium">
                                  Assignment Status
                                </h5>
                                <div className="space-y-2">
                                  {mcqAssignment.assignmentStatus.map(
                                    (assignment) => (
                                      <div
                                        key={assignment.assignmentId}
                                        className="flex items-center justify-between border-b border-gray-100 pb-2 text-sm last:border-0 last:pb-0 dark:border-gray-800"
                                      >
                                        <span
                                          className="max-w-[200px] truncate"
                                          title={assignment.title}
                                        >
                                          {assignment.title}
                                          <span className="ml-2 ">
                                            ({assignment.assignmentSchedule})
                                          </span>
                                        </span>
                                        <span
                                          className={`rounded-full px-2 py-1 text-xs ${getTestStatusColor(
                                            assignment.status
                                          )}`}
                                        >
                                          {assignment.percentage}%
                                        </span>
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Q&A Assignment Details Section */}
                        <div className="mb-6">
                          <h4 className="mb-4 text-sm font-semibold">
                            Q&A Assignment Details
                          </h4>
                          <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                            <div className="rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-navy-900">
                              <h5 className="mb-2 text-sm font-medium">
                                Overview
                              </h5>
                              <div className="space-y-2 text-sm">
                                <p className="flex justify-between">
                                  <span>Total Assignments:</span>
                                  <span>
                                    {qaAssignment?.statistics
                                      .totalAssignments || 0}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>Completed:</span>
                                  <span>
                                    {qaAssignment?.statistics
                                      .completedAssignments || 0}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>In Progress:</span>
                                  <span>
                                    {qaAssignment?.statistics
                                      .inProgressAssignments || 0}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>Average Score:</span>
                                  <span>
                                    {qaAssignment?.statistics.averageScore || 0}
                                    %
                                  </span>
                                </p>
                              </div>
                            </div>
                            {qaAssignment?.assignmentStatus && (
                              <div className="rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-navy-900">
                                <h5 className="mb-2 text-sm font-medium">
                                  Assignment Status
                                </h5>
                                <div className="space-y-2">
                                  {qaAssignment.assignmentStatus.map(
                                    (assignment) => (
                                      <div
                                        key={assignment.assignmentId}
                                        className="flex items-center justify-between border-b border-gray-100 pb-2  text-sm last:border-0 last:pb-0 dark:border-gray-800"
                                      >
                                        <span
                                          className="max-w-[200px] truncate"
                                          title={assignment.title}
                                        >
                                          {assignment.title}
                                          <span className="ml-2 ">
                                            ({assignment.assignmentSchedule})
                                          </span>
                                        </span>
                                        <span
                                          className={`rounded-full px-2 py-1 text-xs ${getTestStatusColor(
                                            assignment.status
                                          )}`}
                                        >
                                          {assignment.percentage}%
                                        </span>
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* /// */}

                        {/* Test Details Section */}
                        <div className="mt-6">
                          <h4 className="mb-4 text-sm font-semibold">
                            Test Details
                          </h4>
                          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                            {/* MCQ Tests Panel */}
                            <div className="rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-navy-900">
                              <h5 className="mb-2 text-sm font-medium">
                                MCQ Tests Overview
                              </h5>
                              <div className="space-y-2 text-sm">
                                <p className="flex justify-between">
                                  <span>Total Tests:</span>
                                  <span>
                                    {mcqStudent?.statistics.totalTests || 0}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>Completed:</span>
                                  <span>
                                    {mcqStudent?.statistics.completedTests || 0}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>In Progress:</span>
                                  <span>
                                    {mcqStudent?.statistics.inProgressTests ||
                                      0}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>Pending:</span>
                                  <span>
                                    {mcqStudent?.statistics.pendingTests || 0}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>Average Score:</span>
                                  <span>
                                    {mcqStudent?.statistics.averageScore || 0}%
                                  </span>
                                </p>
                              </div>
                              {mcqStudent?.testStatus && (
                                <div className="mt-4">
                                  <h6 className="mb-2 text-xs font-medium">
                                    Individual Tests
                                  </h6>
                                  <div className="space-y-2">
                                    {mcqStudent.testStatus.map((test) => (
                                      <div
                                        key={test.testId}
                                        className="flex items-center justify-between border-b border-gray-100 pb-2 text-xs last:border-0 last:pb-0 dark:border-gray-800"
                                      >
                                        <span
                                          className="max-w-[200px] truncate"
                                          title={test.title}
                                        >
                                          {test.title}
                                        </span>
                                        <span
                                          className={`rounded-full px-2 py-1 ${getTestStatusColor(
                                            test.status
                                          )}`}
                                        >
                                          {test.percentage}%
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-navy-900">
                              <h5 className="mb-2 text-sm font-medium">
                                Q&A Tests Overview
                              </h5>
                              <div className="space-y-2 text-sm">
                                <p className="flex justify-between">
                                  <span>Total Tests:</span>
                                  <span>
                                    {qaStudent?.statistics.totalTests || 0}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>Completed:</span>
                                  <span>
                                    {qaStudent?.statistics.completedTests || 0}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>In Progress:</span>
                                  <span>
                                    {qaStudent?.statistics.inProgressTests || 0}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>Pending:</span>
                                  <span>
                                    {qaStudent?.statistics.pendingTests || 0}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>Average Score:</span>
                                  <span>
                                    {qaStudent?.statistics.averageScore || 0}%
                                  </span>
                                </p>
                              </div>
                              {qaStudent?.testStatus && (
                                <div className="mt-4">
                                  <h6 className="mb-2 text-xs font-medium">
                                    Individual Tests
                                  </h6>
                                  <div className="space-y-2">
                                    {qaStudent.testStatus.map((test) => (
                                      <div
                                        key={test.testId}
                                        className="flex items-center justify-between border-b border-gray-100 pb-2 text-xs last:border-0 last:pb-0 dark:border-gray-800"
                                      >
                                        <span
                                          className="max-w-[200px] truncate"
                                          title={test.title}
                                        >
                                          {test.title}
                                        </span>
                                        <span
                                          className={`rounded-full px-2 py-1 ${getTestStatusColor(
                                            test.status
                                          )}`}
                                        >
                                          {test.percentage}%
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                            {/* Mock Tests Panel */}
                            <div className="rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-navy-900">
                              <h5 className="mb-2 text-sm font-medium">
                                Mock Tests Overview
                              </h5>
                              <div className="space-y-2 text-sm">
                                <p className="flex justify-between">
                                  <span>Total Tests:</span>
                                  <span>
                                    {mockStudent?.statistics.totalTests || 0}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>Average Score:</span>
                                  <span>
                                    {mockStudent?.statistics.averageScore || 0}%
                                  </span>
                                </p>
                              </div>
                              {mockStudent?.testStatus?.length > 0 && (
                                <div className="mt-4">
                                  <h6 className="mb-2 text-xs font-medium">
                                    Individual Tests
                                  </h6>
                                  <div className="space-y-2">
                                    {mockStudent.testStatus.map((test) => (
                                      <div
                                        key={test.testId}
                                        className="flex items-center justify-between border-b border-gray-100 pb-2 text-xs last:border-0 last:pb-0 dark:border-gray-800"
                                      >
                                        <span
                                          className="max-w-[200px] truncate"
                                          title={test.subjectName}
                                        >
                                          {test.subjectName}
                                          {test.testDate && (
                                            <span className="ml-2 text-gray-500">
                                              ({new Date(test.testDate).toLocaleDateString()})
                                            </span>
                                          )}
                                        </span>
                                        <span className="rounded-full bg-blue-100 px-2 py-1 text-xs text-blue-800">
                                          {test.Marks != null && test.TotalMarks
                                            ? `${((test.Marks / test.TotalMarks) * 100).toFixed(1)}%`
                                            : 'N/A'}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                            {/* Final Mock Tests Panel */}
                            <div className="rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-navy-900">
                              <h5 className="mb-2 text-sm font-medium">
                                Final Mock Tests Overview
                              </h5>
                              <div className="space-y-2 text-sm">
                                <p className="flex justify-between">
                                  <span>Total Tests:</span>
                                  <span>
                                    {finalMockStudent?.statistics.totalTests || 0}
                                  </span>
                                </p>
                                <p className="flex justify-between">
                                  <span>Average Score:</span>
                                  <span>
                                    {finalMockStudent?.statistics.averageScore || 0}%
                                  </span>
                                </p>
                              </div>
                              {finalMockStudent?.testStatus?.length > 0 && (
                                <div className="mt-4">
                                  <h6 className="mb-2 text-xs font-medium">
                                    Individual Tests
                                  </h6>
                                  <div className="space-y-2">
                                    {finalMockStudent.testStatus.map((test) => {
                                      const pct = test.Marks != null && test.TotalMarks
                                        ? ((test.Marks / test.TotalMarks) * 100).toFixed(1)
                                        : 'N/A';
                                      const pass = test.Marks != null && test.TotalMarks != null && (test.Marks / test.TotalMarks) >= 0.35;
                                      return (
                                        <div
                                          key={test.testId}
                                          className="flex items-center justify-between border-b border-gray-100 pb-2 text-xs last:border-0 last:pb-0 dark:border-gray-800"
                                        >
                                          <span
                                            className="max-w-[200px] truncate"
                                            title={test.subjectName}
                                          >
                                            {test.subjectName}
                                            {test.testDate && (
                                              <span className="ml-2 text-gray-500">
                                                ({new Date(test.testDate).toLocaleDateString()})
                                              </span>
                                            )}
                                          </span>
                                          <span className={`rounded-full px-2 py-1 text-xs ${
                                            pass
                                              ? 'bg-green-100 text-green-800'
                                              : test.Marks != null
                                              ? 'bg-red-100 text-red-800'
                                              : 'bg-gray-100 text-gray-800'
                                          }`}>
                                            {pct}%
                                          </span>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="mt-6">
                          <h4 className="mb-4 text-sm font-semibold">
                            Placement Details
                          </h4>
                          <PlacementDetails
                            data={placementData}
                            isLoading={loadingPlacement}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default StudentOverviewTable;
